<template>
    <div class="content">
        <div class="content-area">
            <div class="contact-information">
                <img src="/static/images/bottom/tel.png" alt="">
                <img src="/static/images/bottom/weixin.png" alt="">
                <img src="/static/images/bottom/phone.png" alt="">
            </div>
            <div class="menu">
                <ul>
                    <li v-for="(item,index) in menu" :key="item.id" :index="index" @click="menuClick(index)">{{item.title}}</li>
                </ul>
            </div>
            <div class="copyright-area">
                <img src="/static/images/bottom/wb-icon.png" style="width: 16px; height: 16px;" />&nbsp;京公网安备 {{copyright.jgwab}}号 备案号：<a href="https://beian.miit.gov.cn/" target="_blank">{{copyright.bah}}</a> &nbsp; {{copyright.copyright}} {{copyright.time}} {{copyright.company}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            menu:dataconfig.menu.data,
            copyright:dataconfig.copyright
        }
    },
    mounted(){
        this.copyright.time = new Date().getFullYear();
    },
    methods:{
        menuClick(index){
            let me = this;
            me.bus.$emit("bottomMenuClick",index)
        }
    }
}
</script>
<style scoped>
   .content{
        width: 100%;
        height: 8rem;
        background: rgb(22,22,22);
        display: flex;
        align-items: center;
    }
    .content-area{
        width: 100%;
        height:60%;
    }
    .contact-information{
        width: 100%;
        height:40%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .contact-information img{
        margin: 0 10px;
        width: 25px;
    }
    .menu{
        width: 100%;
        height: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .menu ul{
        width: auto;
        height: 100%;
        list-style: none;
        margin: 0;
        padding: 0;
        color:#fff;
    }
    .menu ul li{
        width: auto;
        height: 100%;
        float: left;
        margin:0 5px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        padding:0 5px;
        letter-spacing: 1px;
    }
    .menu ul li:not(:last-child)::after{
        position: absolute;
        display: inline-block;
        content:'';
        width: 0px;
        height: 10px;
        border-left:1px solid #fff;
        right: -6px;
    }
    .copyright-area{
        width: 100%;
        height:30%;
        display: flex;
        align-items: center;
        justify-content: center;
        color:#fff;
        font-size: 12px;
    }
    .copyright-area a {
        color:#fff;
    }
</style>


// WEBPACK FOOTER //
// src/view/page/bottom.vue